import type { AutocompleteProps } from '@mui/material';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { extract, withDefault } from '@weft/utils';
import React from 'react';
import { useEventFields } from '../../../../hooks/requests/use-event-fields';

type MeterFieldSelectProps = Omit<AutocompleteProps<string, false, false, true>, 'options' | 'renderInput'> & {
  eventName: string;
  label?: string;
};

export const MeterFieldSelect: React.FC<MeterFieldSelectProps> = ({ eventName, label = 'Field', ...props }) => {
  const { data, isLoading } = useEventFields(eventName);

  const eventFields = withDefault(data?.eventFields, []);
  const eventFieldsNames = extract(eventFields, 'name');

  return (
    <Autocomplete
      size="small"
      {...props}
      options={eventFieldsNames}
      loading={isLoading}
      freeSolo
      autoSelect
      renderInput={(params) => (
        <TextField
          label={label}
          placeholder="Select criterion"
          {...params}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};